import RadioButton from "components/semantic/Radio";
import React, { FC } from "react";

interface QuestionBoxProps {
  question: string;
  SNo: number;
  formProps: any;
  Id: string;
}

const QuestionBox: FC<QuestionBoxProps> = ({ question, SNo, formProps, Id }) => {
  const { values, setFieldValue } = formProps;
  return (
    <div className="text-sm font-medium flex w-full justify-between md:border-none border-y-[1px] border-border-color">
      <div className="flex gap-3 p-5 justify-center items-start">
        <p className="bg-[#E8F6FF] text-black rounded-full min-w-6 min-h-6 aspect-square text-center text-xs md:text-sm font-bold flex justify-center items-center">{SNo}</p>
        <p className="text-sm md:text-base">{question.replace(/^\d+\.\s*/, "")}</p>
      </div>

      <div className="flex flex-col m-1 md:flex-row items-center bg-none md:bg-[#F4F5FA] min-w-36 md:min-w-52 w-36 md:w-52 justify-center gap-3 md:gap-6">
        <RadioButton label="Yes" name={true} value={values[Id]} onChange={() => setFieldValue(Id, true)} />
        <RadioButton label="No" name={false} value={values[Id]} onChange={() => setFieldValue(Id, false)} />
      </div>
    </div>
  );
};

export default QuestionBox;
